import React from 'react'
import { Stack } from '@mui/material'
import CartItem from './CartItem'
import { CanteenCartItem } from '../types'

type Props = {
  cartItems: CanteenCartItem[]
  showQuantity?: boolean
  ordered?: boolean
  hidePrices: boolean
  onUpdate?: (item: CanteenCartItem) => void
  onRemove?: (itemReference: string) => void
}

const CartItemList = (props: Props) => {
  const { onUpdate, onRemove, showQuantity, cartItems, ordered, hidePrices } = props

  const orderedItems = cartItems.reduce<CanteenCartItem[]>((acc, item) => {
    return [...acc, item]
  }, [])

  const items = ordered ? orderedItems : cartItems

  return (
    <Stack spacing={0.5} direction="column">
      {items.map((cartItem) => {
        return (
          <CartItem
            key={`${cartItem.reference ? cartItem.reference : cartItem.id}${cartItem.qty}`}
            hidePrices={hidePrices}
            ordered={ordered}
            cartItem={cartItem}
            onRemove={onRemove}
            onUpdate={onUpdate}
            showQuantity={showQuantity}
          />
        )
      })}
    </Stack>
  )
}

export default CartItemList
